export const OBJECT_SCREEN_TAB_SEARCH_PARAM = 'tab';

export const PENDENCY_KEY_ATTRIBUTE = 'data-pendency-key';

export const DETAILS_SECTION_ATTRIBUTE = 'data-details-section';

export const DETAILS_SECTION_HEADER_ATTRIBUTE = 'data-details-section-header';

export const SECTION_PENDENCY_ALERT_ATTRIBUTE = 'data-section-pendency-alert';

const DETAILS_SECTION_HEADER_CONTENT_HEIGHT_PX = 28;

const DETAILS_SECTION_HEADER_PADDING_Y_PX = 6;

export const PENDENCY_TARGET_MIN_VISIBLE_PX =
  DETAILS_SECTION_HEADER_CONTENT_HEIGHT_PX + 2 * DETAILS_SECTION_HEADER_PADDING_Y_PX;

export const PENDENCY_FAB_TEST_ID = 'object-screen-pendency-fab';

export const OBJECT_CONTENT_PANEL_ID = 'object-screen-content';

export const OBJECT_DETAILS_PANEL_ID = 'object-screen-details';
